export default __webpack_public_path__ + "static/media/witchclose.d89cd0e6.mp3";